import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Head from "../Global/Head";
import Header from "../Global/Header";
import { uploadTableImage } from "../../services/uploadImage";
import InfoCards from "../shared/infoCards/InfoCards";
import { ImCancelCircle } from "react-icons/im";
import axios from "axios";
import SuccessModal from "../main/succesModal/SuccessModal";
import { base_url } from "../../config";

const TableBanner = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get table ID from URL
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreview(URL.createObjectURL(file)); // Generate preview URL
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select an image first!");
      return;
    }

    setIsUploading(true);
    try {
      await uploadTableImage(selectedFile, id);
      toast.success("Image uploaded successfully!");
      // setPreview(null);
      // setSelectedFile(null);
      // navigate(`/profile/myprofile`);
      setOpenModal(true);
    } catch (error) {
      toast.error("Failed to upload image. Please try again.");
    }
    setIsUploading(false);
  };

  const [tableData, setTableData] = useState();
  const fetchDatanotoken = async () => {
    try {
      const response = await axios.get(`${base_url}/tables/view`, {
        params: { id },
        headers: { "Content-Type": "application/json" },
      });
      setTableData(response.data.details);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchDatanotoken();
  }, [id]);




  return (
    <div>
      <ToastContainer />
      <Head />
      <Header />

      <div className="w-full rounded-full h-2.5 mb-6 pt-10 md:px-20">
        <div
          className="bg-[#e2b760] h-2.5 rounded-full transition-all duration-300"
          style={{ width: `100%` }}
        ></div>
      </div>

      <div className="flex md:px-20">
        <div className="md:w-[45rem] md:px-5">
          <Link
            to="/"
            className="px-4 py-2 font-semibold gap-2 mb-3 text-black flex items-center"
          >
            <ImCancelCircle /> Cancel
          </Link>
          <label className=" md:hidden block mb-2 font-semibold text-black text-xl md:text-3xl ">
            Table : {tableData?.title}
          </label>
          <label className="block mb-2 font-semibold text-black text-xl md:text-3xl">
            Upload Table Image
          </label>
          <p className="text-gray-800">
            Please upload an image for the table {tableData?.title}.
          </p>
          <div className="  xl:hidden">
            {/* Image Preview */}
            {preview ? (
              <div className="mt-">
                <p className="text-gray-600 mb-2">Preview:</p>
                <img
                  src={preview}
                  alt="Preview"
                  className="w-full max-w-xs rounded-lg shadow-lg"
                />
              </div>
            ) : (
              <InfoCards />
            )}
          </div>
          {/* File Input with Drag & Drop */}
          <div className="mt-4 flex items-center justify-center w-full">
            <label
              htmlFor="dropzone-file"
              className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
            >
              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <svg
                  className="w-8 h-8 mb-4 text-gray-500"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 16"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                  />
                </svg>
                <p className="mb-2 text-sm text-gray-500">
                  <span className="font-semibold">Click to upload</span> or drag
                  and drop
                </p>
                <p className="text-xs text-gray-500">
                  SVG, PNG, JPG, or GIF (MAX. 800x400px)
                </p>
              </div>
              <input
                id="dropzone-file"
                type="file"
                className="hidden"
                accept="image/*"
                onChange={handleFileChange}
              />
            </label>
          </div>

          {/* Upload Button */}
          <button
            onClick={handleUpload}
            className="px-4 py-2 w-56 bg-[#e2b760] text-base text-white rounded-xl mt-4"
          >
            {isUploading ? "Uploading..." : "Upload Image"}
          </button>
        </div>

        <div className="mt-32 hidden xl:inline">
          {/* Image Preview */}
          {preview ? (
            <div className="mt-">
              <p className="text-gray-600 mb-2">Preview:</p>
              <img
                src={preview}
                alt="Preview"
                className="w-full max-w-xs rounded-lg shadow-lg"
              />
            </div>
          ) : (
            <InfoCards />
          )}
        </div>
      </div>
      {openModal && (
        <SuccessModal
          id={id}
          onClose={() => {
            setOpenModal(false);
            window.location.reload();
          }}
          preview={preview}
        />
      )}
    </div>
  );
};

export default TableBanner;
